import request from '@/utils/request'
const apiPath = '/sys/sysGoodsTag'
const sysGoodsTagApi = {
  /**
   * 新增【商品标签】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【商品标签】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【商品标签】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 查看【商品标签】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【商品标签】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  /**
   * 批量删除【商品标签】
   */
  deleteBatch(ids) {
    return request.delete(apiPath, { data: ids })
  },
  setIsEnableTag(data) {
    return request.put(apiPath + '/setIsEnable', data)
  },
}
export default sysGoodsTagApi
